import Aos from 'aos'
import 'aos/dist/aos.css'
import 'element-ui/lib/theme-chalk/index.css'
import Vue from 'vue'
import BaiduMap from 'vue-baidu-map'
import VueI18n from 'vue-i18n'
import App from './App.vue'
import element from './plugins/element'
import router from './router'
import imgHeader from './components/ImgHeader.vue'
import i18n from './VueI18n'

Aos.init({
  once: true,
})

Vue.use(Aos)
Vue.use(element)
Vue.use(BaiduMap, {
  ak: 'nblAgDR8asULI1Rga98YiQVTSlRDXb4h',
})


Vue.component('imgHeader', imgHeader)

Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
